const svSE= {
    login: {
      title: 'Logga in',
      sign_in_btn: 'Logga in'
    },
    bar: {
        logout: 'Logga ut',
        languages: 'Språk',
        settings: 'Öppna inställningar'
    },
    language: {
      name: 'Svenska (Sverige)',
    },
    attributePage: {
        title: 'Ändringar av egenskaper',
        viewChanges: 'Se ändringar',
        dateTime: 'Datum',
        notificationType: 'Aviseringstyp',
        notificationValue: 'Aviseringsvärde',
        oldValue: 'Gammalt värde',
        newValue: 'Nytt värde',
        accept: 'Godkänn',
        reject: 'Avvisa',
    },
    Home: 'Startsida',
    load: 'Utför inledande laddning ...',
    Requested: "Begärd",
    Viewed: "Visad",
    Executing: "Körs",
    Completed: "Klar",
    Expired: "Inte längre giltig",
    Cancelled: "Avbruten",
    Error: "Fel",
    Rejected: "Avvisad",
    error: 'Ett fel uppstod. Försök igen senare.',
    displayname: 'Visa namn',
    givenname: 'Förnamn',
    surname: 'Efternamn',
    email: 'E-post',
    mail: 'E-post',
    name: 'Förnamn',
    firstname: 'Förnamn',
    lastname: 'Efternamn',
    footer_copyright: 'Alla rättigheter förbehålls.'
  };
  
  export default svSE;
  